import { Link } from "react-router-dom";
const Card = ({ data }) => {



    const { title, text, img, url, like, time, by, btn } = data;
    return (
        <div className="wrapper flex flex-col gap-2 px-2 ">
            <div className="img bg-blue-500 min-w-[280px] md:min-w-[350px] h-[250px] rounded-lg overflow-hidden">
                <img className="h-full" src={img} alt={by} />
            </div>
            <div className="flex flex-col">
                <div className="flex justify-between items-center">
                    <p className="text-black text-sm"><i className="fas fa-heart text-red-600" /> {like}</p>
                    <p className="text-black text-sm"><i className="fas fa-history" /> {time}</p>
                    <Link to="#" className="text-blue-600 font-semibold text-sm"><i className="fas fa-user text-blue-600" /> {by}</Link>
                </div> 
                    <h3 className="title text-black text-[16px] font-semibold">{title}</h3>
                    <p className="text text-black text-[12px]">{text}</p>
            </div>
            <button className="bg-slate-950 text-white py-2 rounded-md"><a href={url}>{btn}</a></button>
        </div>
    )
};
export default Card;